import React from "react";

const IconIncome = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30.552"
      height="28.765"
      viewBox="0 0 30.552 28.765"
    >
      <g
        id="Group_2041"
        dataname="Group 2041"
        transform="translate(2432.436 201.398)"
      >
        <g
          id="Group_2040"
          dataname="Group 2040"
          transform="translate(-2431.936 -186.708)"
        >
          <rect
            id="Rectangle_2515"
            dataname="Rectangle 2515"
            width="4.583"
            height="13.575"
            rx="0.477"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_9336"
            dataname="Path 9336"
            d="M-2427.914-187.438l4.665-2.488A1.393,1.393,0,0,1-2422.1-190l6.841,2.554a1.4,1.4,0,0,1,.9,1.155l.137,1.234"
            transform="translate(2433.309 190.397)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_9337"
            dataname="Path 9337"
            d="M-2427.914-178.181l11.724-.117a1.886,1.886,0,0,0,.958-.276l11.053-8.005a1.014,1.014,0,0,0,.415-.93l-.244-2.3a.41.41,0,0,0-.608-.314l-10.881,6.078-7.016-1.164"
            transform="translate(2433.309 190.369)"
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </g>
        <rect
          id="Rectangle_2516"
          dataname="Rectangle 2516"
          width="11.52"
          height="2.683"
          transform="translate(-2418.149 -191.271)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <rect
          id="Rectangle_2517"
          dataname="Rectangle 2517"
          width="11.52"
          height="2.683"
          transform="translate(-2418.149 -196.085)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <rect
          id="Rectangle_2518"
          dataname="Rectangle 2518"
          width="11.52"
          height="2.683"
          transform="translate(-2418.149 -200.898)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
      </g>
    </svg>
  );
};

export default IconIncome;
